import script from "./DataDatailView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DataDatailView.vue?vue&type=script&lang=ts&setup=true"

import "./DataDatailView.vue?vue&type=style&index=0&id=7691e3ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7691e3ba"]])

export default __exports__